/* CreateMusicVideo.js */

import React from 'react';
import { useHistory } from 'react-router-dom';
// import AppBar1 from '../../components/commom/AppBar1';
import Footer1 from '../../components/commom/Footer1';
import MusicVideoForm from '../../components/remix/MusicVideoForm';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';

export default function CreateMusicVideo() {
  const history = useHistory();

  const callBackAfterCreation = () =>  history.push('/dashboard');
  
  return (
    <>
      <AppBar2 />

      <MusicVideoForm openTinyPageAfterCreation={true} callBackAfterCreation={callBackAfterCreation} createMode />

      <Footer1 />
    </>
  );
}
